var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEn = function SvgEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5338_5984)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5338_5984",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 513,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.5 0H0.5V512H512.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5338_5984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H512.5V512H0.5V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 0V64L322.5 256L512.5 443V512H445.5L254.5 324L68.5 512H0.5V444L186.5 257L0.5 74V0H62.5L254.5 188L440.5 0H512.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 324L195.5 358L42.5 512H0.5V509L184.5 324ZM308.5 312L362.5 320L512.5 467V512L308.5 312ZM512.5 0L320.5 196L316.5 152L466.5 0H512.5ZM0.5 1L193.5 190L134.5 182L0.5 49V1Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 0V512H336.5V0H176.5ZM0.5 176V336H512.5V176H0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 208V304H512.5V208H0.5ZM208.5 0V512H304.5V0H208.5Z",
    fill: "#C8102E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 513,
    height: 512,
    fill: "#CFCFCF",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5338_5984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 512,
    fill: "white"
  })))));
};
export default SvgEn;